import React from 'react';
import './Dots.scss';

export const DotsSVG = () => {
    return (
        <svg
            width="446"
            height="237"
            viewBox="0 0 446 237"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M135.221 236.657C138.615 236.657 141.367 233.793 141.367 230.261C141.367 226.728 138.615 223.865 135.221 223.865C131.826 223.865 129.074 226.728 129.074 230.261C129.074 233.793 131.826 236.657 135.221 236.657Z"
                fill="#E6EEF0"
            />
            <path
                d="M12.2928 51.1691C12.2928 54.7016 9.54096 57.5652 6.1464 57.5652C2.75184 57.5652 -1.34729e-09 54.7016 -1.26029e-09 51.1691C-1.17328e-09 47.6366 2.75184 44.773 6.1464 44.773C9.54096 44.773 12.2928 47.6366 12.2928 51.1691Z"
                fill="#E6EEF0"
            />
            <path
                d="M6.1464 102.338C9.54096 102.338 12.2928 99.4745 12.2928 95.9421C12.2928 92.4096 9.54096 89.5459 6.1464 89.5459C2.75184 89.5459 -2.27603e-09 92.4096 -2.36304e-09 95.9421C-2.45004e-09 99.4745 2.75184 102.338 6.1464 102.338Z"
                fill="#E6EEF0"
            />
            <path
                d="M12.2928 140.715C12.2928 144.248 9.54096 147.111 6.1464 147.111C2.75184 147.111 -3.5528e-09 144.248 -3.46579e-09 140.715C-3.37879e-09 137.183 2.75184 134.319 6.1464 134.319C9.54096 134.319 12.2928 137.183 12.2928 140.715Z"
                fill="#E6EEF0"
            />
            <path
                d="M178.246 236.657C181.64 236.657 184.392 233.793 184.392 230.261C184.392 226.728 181.64 223.865 178.246 223.865C174.851 223.865 172.099 226.728 172.099 230.261C172.099 233.793 174.851 236.657 178.246 236.657Z"
                fill="#E6EEF0"
            />
            <path
                d="M49.1712 12.7923C52.5658 12.7923 55.3176 9.92863 55.3176 6.39614C55.3176 2.86365 52.5658 1.40203e-09 49.1712 1.3115e-09C45.7766 1.22096e-09 43.0248 2.86365 43.0248 6.39614C43.0248 9.92863 45.7766 12.7923 49.1712 12.7923Z"
                fill="#E6EEF0"
            />
            <path
                d="M55.3176 51.1691C55.3176 54.7016 52.5658 57.5652 49.1712 57.5652C45.7766 57.5652 43.0248 54.7016 43.0248 51.1691C43.0248 47.6366 45.7766 44.773 49.1712 44.773C52.5658 44.773 55.3176 47.6366 55.3176 51.1691Z"
                fill="#E6EEF0"
            />
            <path
                d="M49.1712 102.338C52.5658 102.338 55.3176 99.4745 55.3176 95.9421C55.3176 92.4096 52.5658 89.5459 49.1712 89.5459C45.7766 89.5459 43.0248 92.4096 43.0248 95.9421C43.0248 99.4745 45.7766 102.338 49.1712 102.338Z"
                fill="#E6EEF0"
            />
            <path
                d="M55.3176 140.715C55.3176 144.248 52.5658 147.111 49.1712 147.111C45.7766 147.111 43.0248 144.248 43.0248 140.715C43.0248 137.183 45.7766 134.319 49.1712 134.319C52.5658 134.319 55.3176 137.183 55.3176 140.715Z"
                fill="#E6EEF0"
            />
            <path
                d="M49.1712 191.884C52.5658 191.884 55.3176 189.02 55.3176 185.488C55.3176 181.955 52.5658 179.092 49.1712 179.092C45.7766 179.092 43.0248 181.955 43.0248 185.488C43.0248 189.02 45.7766 191.884 49.1712 191.884Z"
                fill="#E6EEF0"
            />
            <path
                d="M55.3176 230.261C55.3176 233.793 52.5658 236.657 49.1712 236.657C45.7766 236.657 43.0248 233.793 43.0248 230.261C43.0248 226.728 45.7766 223.865 49.1712 223.865C52.5658 223.865 55.3176 226.728 55.3176 230.261Z"
                fill="#E6EEF0"
            />
            <path
                d="M227.417 230.261C227.417 233.793 224.665 236.657 221.27 236.657C217.876 236.657 215.124 233.793 215.124 230.261C215.124 226.728 217.876 223.865 221.27 223.865C224.665 223.865 227.417 226.728 227.417 230.261Z"
                fill="#E6EEF0"
            />
            <path
                d="M92.196 57.5652C95.5905 57.5652 98.3424 54.7016 98.3424 51.1691C98.3424 47.6366 95.5905 44.773 92.196 44.773C88.8014 44.773 86.0496 47.6366 86.0496 51.1691C86.0496 54.7016 88.8014 57.5652 92.196 57.5652Z"
                fill="#E6EEF0"
            />
            <path
                d="M98.3424 95.9421C98.3424 99.4745 95.5905 102.338 92.196 102.338C88.8014 102.338 86.0496 99.4745 86.0496 95.9421C86.0496 92.4096 88.8014 89.5459 92.196 89.5459C95.5905 89.5459 98.3424 92.4096 98.3424 95.9421Z"
                fill="#E6EEF0"
            />
            <path
                d="M92.196 147.111C95.5905 147.111 98.3424 144.248 98.3424 140.715C98.3424 137.183 95.5905 134.319 92.196 134.319C88.8014 134.319 86.0496 137.183 86.0496 140.715C86.0496 144.248 88.8014 147.111 92.196 147.111Z"
                fill="#E6EEF0"
            />
            <path
                d="M98.3424 185.488C98.3424 189.02 95.5905 191.884 92.196 191.884C88.8014 191.884 86.0496 189.02 86.0496 185.488C86.0496 181.955 88.8014 179.092 92.196 179.092C95.5905 179.092 98.3424 181.955 98.3424 185.488Z"
                fill="#E6EEF0"
            />
            <path
                d="M92.196 236.657C95.5905 236.657 98.3424 233.793 98.3424 230.261C98.3424 226.728 95.5905 223.865 92.196 223.865C88.8014 223.865 86.0496 226.728 86.0496 230.261C86.0496 233.793 88.8014 236.657 92.196 236.657Z"
                fill="#E6EEF0"
            />
            <path
                d="M270.442 230.261C270.442 233.793 267.69 236.657 264.295 236.657C260.901 236.657 258.149 233.793 258.149 230.261C258.149 226.728 260.901 223.865 264.295 223.865C267.69 223.865 270.442 226.728 270.442 230.261Z"
                fill="#E6EEF0"
            />
            <path
                d="M135.221 57.5652C138.615 57.5652 141.367 54.7016 141.367 51.1691C141.367 47.6366 138.615 44.773 135.221 44.773C131.826 44.773 129.074 47.6366 129.074 51.1691C129.074 54.7016 131.826 57.5652 135.221 57.5652Z"
                fill="#E6EEF0"
            />
            <path
                d="M141.367 95.9421C141.367 99.4745 138.615 102.338 135.221 102.338C131.826 102.338 129.074 99.4745 129.074 95.9421C129.074 92.4096 131.826 89.5459 135.221 89.5459C138.615 89.5459 141.367 92.4096 141.367 95.9421Z"
                fill="#E6EEF0"
            />
            <path
                d="M135.221 147.111C138.615 147.111 141.367 144.248 141.367 140.715C141.367 137.183 138.615 134.319 135.221 134.319C131.826 134.319 129.074 137.183 129.074 140.715C129.074 144.248 131.826 147.111 135.221 147.111Z"
                fill="#E6EEF0"
            />
            <path
                d="M141.367 185.488C141.367 189.02 138.615 191.884 135.221 191.884C131.826 191.884 129.074 189.02 129.074 185.488C129.074 181.955 131.826 179.092 135.221 179.092C138.615 179.092 141.367 181.955 141.367 185.488Z"
                fill="#E6EEF0"
            />
            <path
                d="M315.104 230.261C315.104 233.793 312.352 236.657 308.958 236.657C305.563 236.657 302.811 233.793 302.811 230.261C302.811 226.728 305.563 223.865 308.958 223.865C312.352 223.865 315.104 226.728 315.104 230.261Z"
                fill="#E6EEF0"
            />
            <path
                d="M358.129 230.261C358.129 233.793 355.377 236.657 351.983 236.657C348.588 236.657 345.836 233.793 345.836 230.261C345.836 226.728 348.588 223.865 351.983 223.865C355.377 223.865 358.129 226.728 358.129 230.261Z"
                fill="#E6EEF0"
            />
            <path
                d="M402.604 230.261C402.604 233.793 399.852 236.657 396.458 236.657C393.063 236.657 390.311 233.793 390.311 230.261C390.311 226.728 393.063 223.865 396.458 223.865C399.852 223.865 402.604 226.728 402.604 230.261Z"
                fill="#E6EEF0"
            />
            <path
                d="M445.629 230.261C445.629 233.793 442.877 236.657 439.483 236.657C436.088 236.657 433.336 233.793 433.336 230.261C433.336 226.728 436.088 223.865 439.483 223.865C442.877 223.865 445.629 226.728 445.629 230.261Z"
                fill="#E6EEF0"
            />
        </svg>
    );
};
